module.exports = __webpack_public_path__ + "img/8.fe4af591.png";